import { render, staticRenderFns } from "./Release540.vue?vue&type=template&id=7d1ae2c4"
import script from "./Release540.vue?vue&type=script&lang=js"
export * from "./Release540.vue?vue&type=script&lang=js"
import style0 from "./Release540.vue?vue&type=style&index=0&id=7d1ae2c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports